import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy, ViewChild } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';

@Component({
  selector: 'sm-online-transactions',
  templateUrl: './online-transactions.component.html',
  styleUrls: ['./online-transactions.component.scss']
})
export class OnlineTransactionsComponent implements OnInit, OnDestroy {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Online transactions' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  toDate:any = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
  fromDate:any = ''
  messageList: any[] = [];
  @ViewChild('costTemplate', { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "amount",
      columnProperty: "amount",
      columnTemplate: this.costTemplateRef
    },
    {
      columnName: "payment ID",
      columnProperty: "razorpay_payment_id"
    },
    {
      columnName: "date",
      columnProperty: "creation_time"
    },
    
    
    {
      columnName: "status",
      columnProperty: "payment_status"
    },
  ];
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_ENTITY_SERVICE_PAYMENTS_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creation_time'])) - (+new 
        Date(dataA['creation_time'])))
 
     )
     this.messageList.forEach((item )=> {
     
      if(item.payment_status == '0' ){
        item.payment_status = 'Due'
      }
      if(item.payment_status == '1'){
        item.payment_status = 'Success'
      }
      if(item.payment_status == '2'){
        item.payment_status = 'In progress'
      }
      if(item.payment_status == '3'){
        item.payment_status = 'Error'
      }
     
    })
        console.log( this.messageList);
        
            console.log( this.messageList);
        
      }
      this.loader = false;
      this.visible = true
    });
   }

  ngOnInit(): void {
  
    // this.loader = true  
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
   let todayDate = new Date();
   let beforeDate = new Date(todayDate.setMonth(todayDate.getMonth()-1)).toISOString().replace(/T.*/,'').split('-').join('-');

   
   this.fromDate = beforeDate



  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
  search(){
    console.log(this.fromDate);
    console.log(this.toDate);
    this._apiService.getEntityAllServicePayments(this.entityHashId, this.fromDate, this.toDate)
    this.visible= false
    this.loader = true
  }
}
